import { createFileRoute } from "@tanstack/react-router";
import { PortalIssueRoute } from "@/components/assets/issues/portal-issue-dialog";
import { requirePortalFeature } from "@/lib/portal-data";

export const Route = createFileRoute("/portal/assets/issues/$id")({
  beforeLoad: ({ context }) => requirePortalFeature(context.queryClient, "assets"),
  component: PortalAssetIssuePage,
});

function PortalAssetIssuePage() {
  const { id } = Route.useParams();
  return <PortalIssueRoute issueId={id} />;
}
